// extracted by mini-css-extract-plugin
export default {"footer":"ProductsAssigner_footer__0jDU2"};